const es = {
  navbar: {
    Wallets: "Carteras",
    Transactions: "Transacciones",
    WhiteList: "Lista Blanca",
    Vex: "Intercambio Virtual",
    Invoices: "Facturación",
    Card: "Tarjeta",
    Fiat_Withdrawal: "Retiro Bancario",
    ECommerce: "Mi Comercio",
    login: "Iniciar sesión",
    logout: "Cerrar sesión",
    greeting: "Hola",
  },
  Login: {
    title: "Iniciar sesión",
    welcome: "¡Bienvenido de nuevo!",
    L_mail: "Correo",
    P_mail: "ejemplo@correo.com",
    L_Password: "Contraseña",
    link_Forgot: "¿Has olvidado tu contraseña?",
    SignIn: "¿No tienes una cuenta?",
    createAccount: "Crea tu cuenta",
    errorCaptcha: "Verificar captcha",
    errorEmail: "Formato de correo inválido",
    errorEmpty: "Verificar información, los campos no pueden estar vacíos",
  },
  Forgot: {
    title: "Olvidé mi contraseña",
    L_mail: "Correo",
    P_mail: "ejemplo@correo.com",
    L_Country: "País de nacionalidad",
    link_Forgot: "¿Ya tienes una cuenta? inicia sesión",
    btn: "Enviar correo",
    forgotPage: {
      hi: "Hola",
      L_password: "Contraseña",
      L_cPassword: "Confirmar contraseña",
      btn: "Cambiar contraseña",
    },
  },
  Register: {
    title: "Crea una cuenta",
    L_mail: "Correo",
    P_mail: "ejemplo@correo.com",
    L_name: "Nombre",
    L_lastname: "Apellido",
    L_country: "País",
    L_password: "Contraseña",
    L_cPassword: "Confirmar contraseña",
    L_card: "Tarjeta",
    agree1: "Estoy de acuerdo con los ",
    agree2: "Términos y condiciones",
    btn: "Crear cuenta",
    link: "Reenviar correo de confirmación",
    spam_warning: "En caso de no haber recibido el correo, por favor verifique la carpeta de spam o correo no deseado.",
    text_already: "¿Ya tienes una cuenta?",
    link_logIn: "Inicia sesión",
    confirmation: {
      hi: "Hola",
      yes: "Sí, el correo de confirmación es correcto",
      btn: "Validar",
      link: "Reenviar correo de confirmación",
      M_title: "Reenviar correo",
      L_mail: "Correo",
      P_mail: "example@mail.com",
      L_country: "País",
      M_btn: "Enviar correo",
    },
    messageError: {
      errorTerms: "Debe aceptar los términos y condiciones.",
      errorCaptcha: "Verificar el captcha",
      errorEmpty: "Verificar información, los campos no pueden estar vacíos",
      errorCard: "Formato de Tarjeta inválido",
      errorEmail: "Formato de correo inválido",
      errorPwd: "Ambas contraseñas deben ser similares",
    },
  },
  General: {
    copyToClip: "Copiar al portapapeles",
    copiedToClip: "Copiado en el portapapeles",
    L_Amount: "Monto",
    P_Amount: "$ Monto en USD",
    P_Amount_MXN: "$ Monto en MXN",
    P_AmountC: "Monto en Crypto",
    N_Amount1t: "Usted transferirá",
    N_Amount2t: "tasa",
    N_Amount3: "Aproximadamente",
    L_AmountAvl: "Disponible",
    N_Amount1r: "Usted recibirá",
    N_Amount2r: "de esta transacción",
    filtros: {
      title_filter: "Reciente",
      Date_newest: "Fecha más reciente",
      Date_older: "Fecha más antigua",
      Deposits_lower: "Depósitos menores",
      Deposits_bigger: "Depósitos mayores",
      Label_ascendant: "Etiqueta ascendente",
      Label_descendant: "Etiqueta descendente",
      Amount_lower: "Monto menor",
      Amount_bigger: "Monto mayor",
      Category_received: "Categoría recibida",
      Category_withdrawal: "Categoría retiros",
      showAll: "Mostrar todo",
      Expense: "Gastos",
      Deposits: "Depósitos",
    },
    TwoFa: {
      title: "Confirmar 2FA",
      desc: "Introduzca el código de 6 dígitos de su aplicación Google Authenticator",
      cancel: "Cancelar",
    },
    registerResponse: {
      rejected1: "Su solicitud ha sido rechazada",
      rejected2: "Para verificar la información",
      click: "¡Haga clic aquí!",
      revision: "La información está en proceso de revisión",
      unregistered1: "No has completado el registro",
      unregistered2: "Para completar el registro",
    },
    PassRequirements: {
      req1: "Debe tener al menos 8 caracteres",
      req2: "Debe contener al menos una letra mayúscula",
      req3: "Debe contener al menos una letra minúscula",
      req4: "Debe incluir al menos un dígito",
      req5: "Debe incluir al menos un carácter especial",
      req6: "Las dos contraseñas deben ser iguales",
    },
    months: {
      1: "Enero",
      2: "Febrero",
      3: "Marzo",
      4: "Abril",
      5: "Mayo",
      6: "Junio",
      7: "Julio",
      8: "Agosto",
      9: "Septiembre",
      10: "Octubre",
      11: "Noviembre",
      12: "Diciembre",
    },
  },
  wallets: {
    Index: {
      Account_overview: "Resumen de Cuenta",
      addresses: "Direcciones",
      My_Wallets: "Mis Carteras",
      btn_transfer: "Transferencia Wirebit",
      btn_Stransfer: "Solicitar Transferencia",
      btn_AddWallet: "Agregar cartera",
      input_search: "Moneda o alias",
      t_h_coin: "MONEDA",
      t_h_alias: "ALIAS DE CARTERA",
      t_h_balance: "SALDO",
      t_h_balanceAprox: "SALDO ESTIMADO USD",
      t_h_date: "FECHA",
      btn_next: "Siguiente",
      btn_prev: "Anterior",
      banner_FinishRegis:
        "Completa tu registro para disfrutar toda la experiencia de wirebit.",
      banner_btnComplete: "Completar",
      banner_AccountType: "Tipo de cuenta",
      banner_CurrentAccount1: "Actualmente su tipo de cuenta es",
      data_aproxBalance: "Saldo estimado en USD",
      data_Wallets: "Carteras restantes",
      data_Addresses: "Direcciones restantes",
      modalAdd: {
        title: "Agregar Cartera",
        wallet: "Cartera",
        S_wallet: "Seleccionar...",
        L_Alias: "Alias",
        P_Alias: "Ingresa un alias",
        L_Pass: "Contraseña",
        N_Pass:
          "*Esta contraseña será usada para su cartera, no para su cuenta.",
        btn: "Crear Cartera",
      },
      modalContract: {
        title: "Actualización de Contract",
        text: "Estimado cliente Wirebit, hemos actualizado nuestro Contrato de prestación de servicios, le solicitamos realice su firma nuevamente, cualquier duda o comentario puede comunicarse a hello@wirebit.com",
        continue: "Continuar",
      },
      modalTransfers: {
        Tab_interna: "Transferencia Interna",
        t_i_tooltip: "Transferencia de fondos entre sus propias cuentas",
        Tab_externa: "Transferencia de Cuentas",
        t_e_tooltip: "Pagos/transferencias a otros usuarios de Wirebit",
        L_FromWallets: "De cartera",
        S_Wallets: "Seleccione una cartera",
        L_ToWallets: "A la cartera:",
        L_Amount: "Monto",
        P_Amount: "Monto en USD",
        N_Amount1: "Usted transferirá",
        N_Amount2: "tasa",
        N_Amount3: "Aproximadamente",
        L_AmountAvl: "Disponible",
        L_WalletPass: "Contraseña cartera",
        P_WalletPass: "Contraseña",
        L_Desc: "Descripción",
        P_Desc: "Descripción",
        L_Pass: "Contraseña Cartera",
        P_Pass: "Contraseña",
        L_Alias: "Cuenta Alias",
        P_Alias: "Cuenta Alias",
        L_WAlias: "Alias Cartera",
        P_WAlias: "Alias Cartera",
        btn: "Enviar Transferencia",
        confirmation: {
          title: "Confirmar Transferencia",
          aprox: "Aprox.",
          fromWallet: "Desde cartera",
          description: "Descripción",
          destinyTitle: "Detalles destino",
          accountAlias: "Alias de cuenta",
          walletAlias: "Alias de cartera",
          confirmButton: "Confirmar",
        },
      },
      modalRequest: {
        title: "Solicitar Cuenta de Transferencia",
        L_ToWallets: "A la cartera:",
        S_Wallets: "Seleccione una cartera",
        L_Amount: "Monto",
        P_Amount: "Monto en USD",
        N_Amount1: "Usted transferirá",
        N_Amount2: "tasa",
        N_Amount3: "Aproximadamente",
        L_AmountAvl: "Disponible",
        L_Desc: "Descripción",
        P_Desc: "Descripción",
        copyToClip: "Copiar al portapapeles",
        copiedToClip: "Copiado en el portapapeles",
      },
    },
    overview: {
      Wallet_overview: "Resumen de la cartera",
      toltip_aliasE: "Editar Alias",
      toltip_aliasS: "Guardar cambios",
      rangeFrezeF: "Congelado desde",
      rangeFrezeT: "hasta",
      status_Enabled: "Activa",
      status_Disabled: "Desactiva",
      status_Freze: "Congelada",
      operations: "OPERACIONES",
      Total_Balance: "Balance Total",
      AproxUSDBalance: "Saldo estimado en USD",
      Deposits: "Depósitos",
      Withdrawals: "Retiros",
      Addresses: "Direcciones",
      options: "OPCIONES",
      L_wallet: "Cartera",
      ReqWithdrawal: "Solicitar un retiro",
      changePass: "Cambiar la contraseña",
      EnableWallet: "Activar el monedero",
      FreezeWallet: "Congelar la cartera",
      btn_With: "Retirar",
      btn_Change: "Cambiar",
      btn_Enabled: "Activar",
      btn_Disabled: "Desactivar",
      btn_Freeze: "Congelar",
      btn_UnFreeze: "Descongelar",
      Transactions: "Transacciones",
      seeMore: "Ver más",
      L_sort: "Ordenar por",
      L_search: "Buscar",
      AddressesTitleXrp: "Dirección de la cuenta",
      btn_Add: "Añadir dirección",
      btn_AddTag: "Añadir etiqueta",
      warning_bch:
        "Si tienes problemas para hacer un deposito/retiros a tu cuenta de bitcoincash, te recordamos que algunas plataformas requieren que elimines el sufijo “bitcoincash:” para poder enviar tus cryptoactivos.",
      T_h_ADDRESS: "DIRECCIÓN",
      T_h_TAG: "ETIQUETA",
      T_h_LABEL: "ALIAS DE DIRECCIÓN",
      T_h_deposits: "DEPÓSITOS",
      T_h_date: "FECHA",
      T_h_qr: "QR",
      Password: "Contraseña",
      modalWithdrawal: {
        title: "Solicitud de retiro",
        L_coin: "Moneda",
        L_address: "Dirección",
        L_Description: "Descripción",
        L_Amount: "Monto",
        L_Available: "Disponible",
        N_Amount1: "Usted recibirá",
        N_Amount2: "de esta transacción",
        N_Amount3: "Aproximadamente",
        btn: "Solicitar retiro",
        L_Tag: "Etiqueta",
        select: "Seleccione una dirección",
        invalidAddrss: "La dirección capturada no es válida",
        invalidOmni:
          "La dirección de destino debe coincidir con la red de retiro: Omni",
        network: "Red",
        invalidSolana:
          "La dirección de destino debe coincidir con la red de retiro: Solana",
      },
      modalChangePass: {
        title: "Cambiar contraseña de la cartera",
        L_NewPass: "Nueva contraseña",
        L_ConfirmPass: "Confirmar contraseña",
        L_ReqPass: "Requisitos de la contraseña",
        L_current: "Contraseña de WBD",
        req_1: "Debe tener al menos 8 caracteres",
        req_2: "Debe contener al menos una letra mayúscula",
        req_3: "Debe contener al menos una letra minúscula",
        req_4: "Debe incluir al menos un dígito",
        req_5: "Debe incluir al menos un carácter especial",
        req_6: "Ambas contraseñas deben ser iguales",
        btn: "Cambiar",
      },
      modalWalletLockFreeze: {
        titleWL: "Bloqueo de la Cartera",
        titleWF: "Congelar cartera",
        L_DateFrom: "Desde",
        L_DateTo: "Hasta",
        AccountPassword: "Contraseña de cuenta Wirebit",
        WalletPassword: "Contraseña de cartera",
      },
      modalWithdrawalInfo: {
        title: "Condiciones de retiro",
        L_TransFee: "Comisión de transacción",
        L_Address: "Dirección",
        D_Address: "La dirección debe ser válida",
        MinWith: "Importe mínimo de retirada",
        L_TransferFee: "Comisión por transferencia",
        D_TrasnferFee_i: "Interna",
        D_TrasnferFee_a: "Cuentas",
        D_TrasnferFee_iv: "Facturas",
      },
      modalFreeze: {
        title: "Congelar Cartera",
        L_DateF: "Fecha desde",
        L_DateT: "Fecha hasta",
        btn: "Congelar Cartera",
      },
    },
    transacciones: {
      header_1: "Saldo de la cartera en USD",
      header_2: "Saldo de la cartera",
      header_3_E: "Activado",
      header_3_D: "Desactivado",
      header_3_F: "Congelada",
      header_4: "Depósitos",
      header_5: "Retiros",
      title: "Transacciones",
      exportCSV: "Exportar a csv",
      goBack: "Volver a la cartera",
      L_sort: "Ordenar por",
      L_search: "Buscar",
      L_dateF: "Fecha desde",
      L_dateT: "Fecha hasta",
      T_H_WA: "cartera / dirección",
      T_H_category: "categoría",
      T_H_label: "etiqueta",
      T_H_status: "estado",
      T_H_amount: "monto",
      T_H_USDamount: "monto USD",
      T_H_date: "fecha",
      T_H_txid: "txid",
    },
  },
  transacciones: {
    title: "Transacciones en la Cuenta",
    exportCSV: "Exportar a csv",
    L_sort: "Ordenar por",
    L_search: "Buscar",
    L_dateF: "Fecha desde",
    L_dateT: "Fecha hasta",
    T_H_WA: "cartera / dirección",
    T_H_category: "categoría",
    T_H_label: "etiqueta",
    T_H_status: "estado",
    T_H_amount: "monto",
    T_H_USDamount: "monto USD",
    T_H_date: "fecha",
    T_H_txid: "txid",
    tooltip_hover: "Alias de Cartera",
  },
  whitelist: {
    alert:
      "Su lista blanca está desactivada, puede activar esta función a través de su ventana de configuración",
    title: "Direcciones",
    addAddrss: "Añadir dirección",
    L_Coin: "Moneda",
    L_SelectCoin: "Seleccionar una moneda",
    L_Status: "Estado",
    L_StatusE: "Activado",
    L_StatusD: "Desactivado",
    L_SelectStatus: "Selecciona un estado",
    L_Search: "Buscar",
    T_H_WA: "cartera / dirección",
    T_H_label: "etiqueta",
    T_H_status: "estado",
    T_H_maxAmount: "monto máximo",
    ModalAddAddress: {
      title: "Añadir dirección a la lista blanca",
      L_Wallet: "Cartera",
      L_Address: "Dirección",
      L_AddressError: "La dirección capturada no es válida",
      L_Tag: "Tag Id",
      L_Label: "Etiqueta",
      L_Amount: "Monto",
      P_Amount: "Monto USD",
      L_Amountn1: "Aproximadamente",
      L_Amountn2:
        "Monto: limita la cantidad máxima de cripto que se puede transferir en una sola transacción",
      btn: "Añadir dirección",
    },
    ModalEditAddress: {
      L_TagId: "Tag Id",
      L_label: "Etiqueta",
      L_MaxAmount: "Monto máximo",
      L_MaxAmountAprox: "Aproximadamente",
      P_Amount: "Monto",
      P_Amount2: "Monto USD",
      L_Status: "Estado",
      btn: "Guardar cambios",
    },
  },
  VEX: {
    wallet: "Carteras",
    addresses: "Direcciones",
    titleEX: "Intercambio",
    get: "Obtiene",
    intrument_exchange: "Instrumento a cambiar",
    intrument_get: "Instrumento a recibir",
    tdc: "Pago con tarjeta",
    Fee: "Comisión",
    exchange_from: "De",
    exchange_to: "Hacia",
    virtualUSD: "USD Virtual",
    placeholder_coin: "Seleccione un instrumento",
    market_price: "Precio de mercado",
    L_selectWallet: "Seleccion una cartera",
    selectWallet: "Seleccione una cartera",
    walletBalance: "Balance de la cartera",
    t_h_instrument: "Moneda",
    balance: "Mi balance",
    L_Pair: "PAR",
    L_Amount: "Monto",
    USDApprox: "Valor Estimado USD",
    btn_buy: "Compra Mercado",
    btn_sell: "Venta Mercado",
    titleT: "Transacciones",
    L_sort: "Ordenar por",
    L_dateF: "fecha desde",
    L_estimated: "Estimado",
    L_dateT: "fecha hasta",
    L_search: "Buscar",
    T_H_pair: "PAR",
    T_H_wallet: "CARTERA",
    T_H_category: "CATEGORÍA",
    T_H_amount: "MONTO",
    T_H_price: "PRECIO",
    T_H_status: "ESTATUS",
    T_H_date: "FECHA",
    emptyWallet: "Agrega una cartera para continuar el proceso",
    modalCreateOrder: {
      title: "Crear orden",
      confirm: "Confirmar orden de intercambio",
      WalletSelected: "Cartera seleccionada",
      MarketB: "Mercado de compra",
      MarketS: "Mercado de venta",
      Amount: "Monto",
      Confirm: "Confirmar",
      Cancelar: "Cancelar",
      get: "Obtiene",
      fee: "Comisión",
      From: "De",
      To: "A",
      price: "Precio",
    },
    transacciones: {
      title: "Transacciones",
      L_sort: "Ordenar por",
      L_search: "Buscar",
      L_dateF: "Fecha desde",
      L_dateT: "Fecha hasta",
      T_H_Pair: "Par",
      T_H_WA: "Cartera",
      T_H_category: "categoría",
      T_H_amount: "monto",
      T_H_Price: "precio",
      T_H_status: "estado",
      T_H_date: "fecha",
    },
  },
  Card: {
    riseLimit:{
      btn_link_rise: 'Incrementar límite de depósito',
      title: 'Solicitar incremento al límite de depósito',
      label_ammount: 'Incremento deseado (USD)',
      label_reason: 'Descripción de solicitud',
      calculated_amount: 'Aprox.',
      placeholder_amount: 'Monto USD',
      count_characters: 'Max. 250 caracteres',
      btn_send_request: 'Enviar solicitud',
      modal_confirm: 'Solicitud enviada exitosamente',
      msg_confirm: 'Te notificaremos vía correo electrónico\n en cuanto quede autorizada.',
      btn_close: 'Cerrar'
    },
    disabled: {
      note1: "Solicite aquí su tarjeta Wirebit",
      btn: "Solicitar tarjeta",
      note2:
        "Tarifa de envío después de la aprobación (Disponible para pagar con cualquiera de sus carteras)",
      note3: "",
    },
    payment: {
      title: "Pago de tarjeta",
      L_Wallet: "Carteras",
      P_Wallet: "Seleccione una cartera",
      L_Description: "Descripción",
      P_Description: "Pago de tarjeta",
      L_pass: "Contraseña",
      P_pass: "Contraseña de la cartera",
      btn: "Enviar pago",
    },
    assignation: {
      title: "Su tarjeta está en camino, regístrela cuando llegue",
      btn: "Registrar tarjeta",
      M1_title: "Agregar tarjeta",
      M1_L_input: "Ingresa los 16 dígitos de tu tarjeta",
      M1_btn: "Validar",
      M2_title: "¡Tarjeta registrada!",
      M2_PinNote: "El PIN de su tarjeta es",
      help_text: "Necesitas ayuda",
      contact_text: "Contáctanos",
    },
    transaction_list:
      "No se encontraron transacciones en el rango seleccionado",
    enabled: {
      L_Status: "Estado",
      L_StatusU: "Desbloqueada",
      L_StatusB: "Bloqueada",
      L_Detail: "Detalle",
      btn_StatusU: "Desbloquear",
      btn_StatusB: "Bloquear",
      L_Card_Digital: "Tarjeta digital",
      btn_Pin: "Solicitar Pin",
      tab_deposit: "Depositar en la tarjeta",
      tab_Withdra: "Retiro de la tarjeta",
      L_avlDeposit: "Disponible para depositar",
      L_avlWithdra: "Disponible para retirar",
      btn_Deposit: "Depositar",
      btn_withdra: "Retirar",
      note_Deposit1: "El límite de depósitos por mes para esta tarjeta es",
      note_Deposit2: "Si necesita una cantidad de depósito mayor",
      btn_Link_increase: "Incrementar límite de depósito",
      note_Withdra: "Límite de retiro por mes en esta cuenta",
      cardBalnce: "Saldo de la tarjeta",
      virtualUSD: "Saldo de USD virtual",
      L_operations: "Operaciones",
      L_DateFrom: "Fecha desde",
      L_DateTo: "Fecha hasta",
      L_Transaction: "Movimientos",
      L_empty_transactions_1: "Por el momento no",
      L_empty_transactions_2: "hay ningún movimiento",
      L_add_card: "Agregar tarjeta",
      Btn_new_Card: "+ Nueva Tarjeta",
      btn_accept: "Aceptar",
      modalRegister: {
        success: {
          title: "Tarjeta agregada",
          subtitle: "Tu tarjeta fue agregada con éxito",
          btn_init: "Comenzar",
        },
        failed: {
          title: "Tarjeta no válida",
          msg: "Parece que hubo un problema con la tarjeta,\n vuelve a intentar o contacta a uno de\nnuestros ejecutivos.",
          btn_back: "Regresar",
          btn_contact: "Contáctanos",
        },
      },
      modalPin: {
        title: "Solicitar PIN",
        note: "Para recibir su PIN necesitaremos verificar su identidad con un código de verificación sms enviado a su teléfono",
        btn_Send: "Enviar código de verificación",
        link: "¿Ya tiene su código de verificación?",
        title2: "Introduzca el código de verificación",
        L_code: "Código de verificación",
        P_code: "Introduzca el código",
        btn_request: "Solicitar PIN",
        success: "Éxito",
        L_Pin: "El PIN de su tarjeta es",
      },
      modalTransaction: {
        title: "Detalle de movimiento",
        L_organization: "Organización",
        L_withdrawal_account: "Cuenta retiro",
        L_amount: "Importe",
        L_movement_type: "Tipo de movimiento",
        L_concept: "Concepto movimiento",
        L_commerce: "Comercio",
        L_reference_number: "Número de referencia",
        L_unrecognized: "Movimiento no reconocido",
        L_config: "Configurar",
      },
      modalBlockDigital: {
        title: "Bloquear Tarjeta",
        titleUnblock: "Desbloquear Tarjeta",
        body: "¿Estás seguro de que quieres bloquear tu\n tarjeta? No podrás usarla hasta que\n la desbloquees de nuevo",
        bodyUnblock:
          "¿Estás seguro de que quieres desbloquear tu\n tarjeta? Esta quedará nuevamente\n activa para su uso",
      },
      modalBlockPhysical: {
        title: "Bloquear Tarjeta",
        titleUnblock: "Desbloquear Tarjeta",
        body: "¿Estás seguro de que quieres bloquear tu\n tarjeta? No podrás usarla hasta que\n la desbloquees de nuevo",
        bodyUnblock:
          "¿Estás seguro de que quieres desbloquear tu\n tarjeta? Esta quedará nuevamente\n activa para su uso",
      },
      modalSettings: {
        title: "Configuration",
        L_reposition: "Reposición de tarjeta",
        L_cancel: "Cancelar tarjeta",
      },
      modalCardReplacement: {
        title: "Reposición de tarjeta",
        L_body: "Favor de llamar al siguiente número:",
        L_cancel: "Cancelar",
      },
      modalCardCancelation: {
        title: "Cancelar tarjeta",
        L_body: "Favor de llamar al siguiente número:",
        L_cancel: "Cancelar",
      },
      modalUnrecognized: {
        title: "Movimiento no reconocido",
        L_body: "Favor de llamar al siguiente número:",
        L_cancel: "Cancelar",
      },
      physicalCard: {
        title: "Tarjeta física",
        L_card_number: "Número de tarjeta",
        L_copy: "Copiar",
        L_expiration_date: "Fecha de vencimiento",
        L_pin: "Pin",
        L_config: "Configuración",
        L_card_copied_title: "¡Hecho!",
        L_card_copied_message: "Número de tarjeta copiado al portapapeles",
      },
      digitalCard: {
        title: "Tarjeta digital",
        L_card_number: "Número de tarjeta",
        L_copy: "Copiar",
        L_expiration_date: "Fecha de vencimiento",
        L_cvv: "CVV",
        L_hide: "Ocultar",
        L_show: "Solicitar",
        L_time_warning_1: "Tu código de seguridad CVV,",
        L_time_warning_2: "será válido solo 5 minutos",
        L_card_copied_title: "¡Hecho!",
        L_card_copied_message: "Número de tarjeta copiado al portapapeles",
      },
    },
    warning: {
      msg: "El servicio está en mantenimiento.",
    },
  },
  settings: {
    tab_Personal: "Información Personal",
    tab_Bank: "Información Bancaria",
    tab_Services: "Servicios",
    personal: {
      title: "Información",

      titleAccount: "Información de cuenta",
      L_email: "Correo",
      L_name: "Nombre",
      L_Country: "País",
      L_Status: "Estado de la cuenta",
      L_Last_Login: "Último inicio de sesión",
      L_Registration_Date: "Fecha de registro",

      titleBasic: "Información básica",
      L_FistName: "Nombre",
      L_fatherLastName: "Apellido Paterno",
      L_motherLastName: "Apellido Materno",
      L_DateBirth: "Fecha de Nacimiento ",
      L_Country: "País de Nacionalidad",
      L_Curp: "CURP",
      L_rfc: "RFC / ID Fiscal",
      L_Profession: "Actividad Económica/ Profesión ",

      titleCompany: "Información de la empresa",
      bussines_name: "Denominación o razón social",
      bussines_country: "País de Constitución",
      bussines_date: "Fecha de Constitución",
      bussines_rfc: "RFC / ID Fiscal",
      bussines_line: "Giro mercantil",
      titleRepresentative: "Información del representante legal",
      L_CountryBirth: "País de nacimiento",

      titleAddress: "Información de Domicilio",
      Addss_Country: "País ",
      Addss_State: "Estado/ Departamento/ Provincias",
      Addss_Municipio: "Municipio / Delegación",
      Addss_City: "Ciudad",
      Addss_Colony: "Colonia / Urb.",
      Addss_Street: "Calle, avenida o vía",
      Addss_id: "ID de domicilio /Número exterior/ nombre",
      Addss_Int: "Número Interior",
      Addss_Zip: "Código Postal",
    },
    bank: {
      title: "Información bancaria",
      bk_status: "Estado de la solicitud bancaria",
      bk_name: "Nombre de Banco",
      bk_country: "País del Banco",
      bk_state: "Estado del Banco",
      bk_city: "Ciudad del Banco",
      bk_zip: "Código postal del Banco",
      bk_address: "Dirección del Banco",
      bk_Intermediary: "Banco Intermediario",
      bk_BillingAddss: "Dirección de facturación",
      bk_accountNumber: "Número de cuenta bancaria",
      bk_currency: "Divisa de la cuenta",
      bk_Aba: "ABA",
      bk_swift: "SWIFT",
      bk_spid: "SPID",
      bk_CLABE: "CLABE de la cuenta bancaria",
      btn_remove: "Eliminar Banco",
      btn_add: "Agregar banco",

      bk_statement: "Caratula Estado de cuenta",

      L_applicable: "si es aplicable",

      btn_save: "Save Bank",
    },
    services: {
      titleApiKeys: "Api Keys",
      T_H_api: "Api Keys",
      T_H_status: "ESTADO",
      T_H_lastUse: "ÚLTIMO USO",
      T_H_apiSecret: "API SECRET",
      T_H_apiTOTP: "API TOTP",
      btnCreateKey: "Crear Api Key",

      L_Alias: "Alias de cuenta Wirebit",
      btn_Alias: "Cambiar Alias",
      L_Passwor: "Cambiar contraseña",
      L_whiteList: "Lista Blanca",
      L_status: "Estado",
      L_statusE: "Activo",
      L_statusD: "Desactivado",
      btn_statusE: "Activar",
      btn_statusD: "Descativar",

      L_lang: "idioma",
      L_langE: "Inglés",
      L_langS: "Español",

      modalAlis: {
        L_newAlias: "Nuevo Alias",
        note: "Nota: Elija sabiamente su Alias. No utilice caracteres especiales ni espacios, de 8 a 32 caracteres como máximo",
        btn_save: "Guardar cambios",
      },
      modalChangePass: {
        L_current: "Contraseña actual",
        L_new: "Nueva contraseña",
        L_confirm: "Confirmar Contraseña",
        L_requirements: "Requisitos de la contraseña",
        btn_Cancel: "Cancelar",
      },
      modalTwoFa: {
        mA_open: "Abre tu aplicación Google Authenticator",
        mA_Select: "Selecciona el botón de Escanear código de barras",
        mA_Scan: "Escanea el siguiente QR",
        mA_scaned: "Ya he escaneado el QR",
        btn_Cancel: "Cancelar",
        btn_Back: "Volver",

        titleA: "Activar 2FA",
        titleD: "Desactivar 2FA",

        warning:
          "ADVERTENCIA: Le recomendamos que utilice siempre la autenticación 2FA para mantener su cuenta y sus transacciones seguras",
      },
    },
  },
  Withdrawal: {
    L_W_type: "Tipo de retiro",
    L_W_typeC: "Tarjeta",
    L_W_typeB: "Transferencia bancaria",
    note: "Esta sección es para retiros de su USD/MXN Virtual a su banco o a su tarjeta",
    note2: "Esta sección es para retiros de su USD/MXN Virtual a su banco",

    L_name: "Nombre",
    L_email: "Correo",
    L_Card: "Tarjeta",
    L_Amount: "Importe del retiro",
    L_Available: "Disponible",
    L_AmountNote: "Retirará aproximadamente",
    L_note:
      "El importe mínimo de la transferencia es de 40 usd. Las transferencias tardarán de 24 a 72 horas hábiles.",
    L_note_mxn:
      "El importe mínimo de la transferencia es de 800 mxn. Las transferencias tardarán de 24 a 72 horas hábiles.",

    btn_send: "Solicitar retiro",

    L_note_bk:
      "No tiene información bancaria o está en proceso de autorización",
    L_note2_bk: "Para rellenar sus datos bancarios o comprobar su estado",

    L_selectBank: "Seleccione una cuenta bancaria",
  },
  invoice: {
    title: "Factura de pago",
    deadline: "Fecha límite",
    T_H_coin: "Moneda",
    T_H_addss: "Dirección de pago",
    T_H_Calcu: "Calculadora de USD",
    Notice1: "Aviso: Esto son aproximaciones en USD usando precios locales",
    Notice2: "Por favor, siéntase libre de calcular sus propias cantidades",
    btn_Pay: "Pagar la factura",

    M_title: "Pago de la factura",
    L_wallet: "Carteras",
    P_wallet: "Seleccione una cartera",
    L_address: "Dirección",
    L_description: "Descripción",
    L_password: "Contraseña",
    btn_send: "Enviar pago",

    titleHistory: "Historial de pagos",
    T_H_priod: "Período",
    T_H_status: "Estado",
    Invoice: "Factura",
    L_billed: "Facturado a",
    L_legalRep: "Representante legal",
    L_street: "DIRECCIÓN DE LA CALLE",
    L_country: "PAÍS",
    L_CELLPHONE: "TELÉFONO MÓVIL",
    L_info: "Información de la factura",
    L_coin: "Moneda",
    L_status: "ESTADO",
    L_DATE: "FECHA",
    btn_download: "Descarga",
    L_AMOUNT: "MONTO",
    note: "Para más información, póngase en contacto con nosotros en",
  },
  kyc: {
    choose: {
      title_mobile: "Selecciona tu tipo de entidad",
      title: "Elige tu tipo de entidad",
      subtitle: "Los archivos deben de ser .jpeg .png .jpg o pdf y no\ndebe pesar más de 8MB",
      desc: "Persona física o persona moral",
      description: "Necesitarás los siguientes archivos e información:",
      physical: "Persona física",
      p_req: "RFC / Documento de identificación Tributaria",
      p_req1: "ID frente y posterior o Pasaporte",
      p_req2: "Selfie ID",
      p_req3: "Comprobante de domicilio",
      p_req4: "Información general del cliente",
      youHave: "Ya tienes este plan",
      moral: "Persona moral",
      m_req_0: "RFC / Documento de identificación Tributaria: Representante legal y empresa",
      m_req: "ID frente y posterior o Pasaporte",
      m_req1: "Selfie ID",
      m_req2: "Acta constitutiva",
      m_req3: "Comprobante de domicilio",
      m_req4: "Información del representante legal",
      m_req5: "Información general de empresa",

      plan_desc: "Necesitará la siguiente información",
      plan_files_format: "Todos los archivos deben de ser .jpeg, .png, .jpg ó .pdf",

      L_Continue: "Continuar",
      L_Choose: "Elegir",

      M_cell_title: "Verificación del teléfono",
      M_cell_note:
        "Por favor, introduzca el código que se envió al número que introdujo",
      M_cell_code: "Código",
      M_cell_CaptureCode: "Capturar el código",
      M_cell_valid: "Validar",
      M_cell_resend: "Reenviar código",
      M_cell_change: "Cambiar el número de teléfono",
      M_cell_verif: "Verificación del teléfono",
      M_cell_note2:
        "Por favor, verifique un número de teléfono celular antes de elegir un formulario",
      M_cell_phone: "Teléfono celular",
      M_cell_btn: "Enviar código",
    },
    form: {
      header_1: "Información básica",
      header_2: "Dirección",
      header_3: "Información bancaria (opcional)",
      finalmsg: "¡Tu registro se completó con éxito!",
      subtitle1: "Crea tu primera",
      subtitle2: "Wallet",
      subtitle3: "y solicita tu",
      subtitle4: "tarjeta Wirebit.",
      textWallet_1: '1. Entra en la sección “Mis Carteras”. Haz click en el botón “Agregar Cartera”.',
      textWallet_2: '2. Selecciona la moneda de tu preferencia, elige un alias y crea una contraseña para esa cartera.',
      textWallet_3: '3. Crea una dirección donde podrás fondear tu cartera.',
      textWallet_4: '4. Solicita tu tarjeta en la sección de “Tarjeta”.',
      textWallet2: 'Comienza a usar todo el potencial que',
      textWallet3: 'Wirebit',
      textWallet4: 'ofrece para ti.',
      btnCreateWallet: 'Crear wallet',
      GoHome: "Regresar al inicio",
      general: {
        Name: "Nombre",
        Father_Surname: "Apellido paterno",
        Mother_Surname: "Apellido materno",
        Date_Birth: "Fecha de nacimiento",
        Country_Birth: "País de nacimiento",
        RFC: " / Documento de identificación Tributaria",
        fiscalID: 'Documento de identificación Tributaria', 
        Nationality: "Nacionalidad",
        EconomicAct: "Actividad Económica / Profesión ",
        idPassportNum: "Número de ID o pasaporte",
        idFront: 'ID frontal',
        idBack: 'ID posterior',
        selfieID: 'Autorretrato ID',
        IdF: "ID del representante legal (frente)",
        idB: "ID del representante legal (reverso)",
        id: "ID (vista frontal y posterior)",
        Passport: "Pasaporte",
        Articles_Incorporation: "Acta constitutiva",
        Last_Articles_Incorporation: "Última modificación de los estatutos",
        Continue: "Continuar",
        optional: "opcional",
        skip: "Omitir",
        if_applicable: "si es el caso",
      },
      moral: {
        Business_Name: "Denominación o razón social",
        Date_Incorporation: "Fecha de constitución",
        country: "País de constitución",
        Line_Business: "Giro mercantil",
        part2: "Información del representante legal",
        Public_register: "Registro público",
        company: "Empresa",
        legalRep: "Representante legal",
        help_tools: {
          bussines_name: "Nombre de compañía",
          bussines_name_description: 'Nombre con el que la empresa se\n encuentra registrada legalmente',
          birthdate_company_description: 'Fecha en que la empresa se\n constituyó legalmente',
          country_incorporation_description: 'País donde la empresa se\n constituyó legalmente',
          rfc_company_description: 'Número de identificación Fiscal,',
          rfc_company_description_2: 'su nombre varía en cada país',
          selfie_id : 'Toma una fotografía sosteniendo tu\n identificación oficial con la mano',
          selfie_id_description_2: 'No tapes con la mano tu identificación',
          selfie_id_description_3: 'Toma la selfie en un espacio con luz clara',
          selfie_id_description_4: 'Asegurate de que tu foto sea nítida',
          f_constitutive_act_description: 'Testimonio o copia certificada del\n instrumento público que acredite\n su constitución, e inscripción en el\n registro público que corresponda.',
          f_constitutive_act_description_2: 'Acta constitutiva de la empresa',
          curp_description: 'Clave única de registro de población\n para ciudadanos y residentes mexicanos',
          passport_title: 'Número Pasaporte',
          passport_description: 'El número de pasaporte lo encuentras en\n la parte superior derecha del laminado de tu pasaporte.',
          id_title: 'Número ID',
          id_description: 'El número de ID es una combinación\n de letras y números que identifican a la\n credencial, no a la persona',
          f_utility_bill_title: 'Comprobante Domicilio',
          f_utility_bill: 'Debe ser menor a 3 meses de antigüedad\n luz, agua, teléfono fijo y/o\n caratula bancaria'
        }
      },
      address: {
        country: "País",
        state: "Estado",
        P_state: "Estado / Departamento / Provincias",
        T_state:
          "El estado donde reside, los estados tienen gobernadores, Ejemplo: Estado de Florida, Estado de Nuevo León, Departamento de Antioquia.",
        delegation: "Delegación",
        P_delegation: "Delegación / Municipio / Comarca",
        T_delegation:
          "Delegación, Municipio donde reside, los municipios tienen un Alcalde, Ejemplo: Condado de Nueva York, Municipio de Bogotá",
        city: "Ciudad",
        Neighborhood: "Colonia",
        P_Neighborhood: "Barrio / complejo residencial / sector",
        T_Neighborhood:
          "La zona donde vives, la zona donde se encuentra tu dirección",
        Street: "Calle",
        P_Street: "Calle / Avenida / Carretera",
        BuildingNumber: "Número de edificio / Casa",
        Apartament: "Número de apartamento / oficina",
        ZipCode: "Código postal",
        ProofAddress: "Comprobante de domicilio",
      },
      bank: {
        note: 'Si no necesita ningún depósito en su cuenta bancaria, puede descartar este paso y hacer clic en el botón inferior "omitir". Si omite este paso puede cargar su información bancaria en la sección de configuración y en la pestaña de información bancaria.',
        b_name: "Nombre del banco",
        b_country: "País del banco",
        b_state: "Estado del banco",
        b_city: "Ciudad del banco",
        b_zipCode: "Código postal del banco",
        b_address: "Dirección del banco",
        b_Intermediary: "Intermediario bancario",
        b_BillingAddress: "Dirección de facturación",
        b_AccountNumber: "Número de cuenta bancaria",
        b_AccountCurrency: "Moneda de cuenta bancaria",
        b_Currency: "Divisa de la cuenta bancaria",
        b_CLABE: "CLABE de la cuenta bancaria",
        b_Account_Statement: "Portada del banco, extracto de cuenta",
      },
      Contract: "Contrato",
      Clear: "Borrar",
      Confirm: "Confirmar",
      Signature: "Firma",
    },
  },
  ecomm: {
    modal: {
      title: "No cuentas con un comercio registrado",
      text: "Llena el formulario de inicio y listo",
      button: "¡Comienza ahora!",
    },
    msg_validation: 'Máximo de 18 caracteres',
    myecomm: "Mi comercio",
    vextitle: "Cambio a",
    goBack: "Regresar",
    fiatW: "Retiros FIAT",
    download_btn: "Descargar",
    auto: {
      disabled: "Manualmente",
      enabled: "Automaticamente",
    },
    0: "Manualmente",
    daily: "Diario",
    48: "Cada 48 horas",
    history: "Historial de ordenes",
    b_devices: "Dispositivos",
    b_addDevice: "Agregar dispositivo",
    b_wallets: "Carteras",
    b_settings: "Configuración",
    b_thats: "That's it web",
    starting_date: "Fecha inicio",
    ending_date: "Fecha fin",
    search: "Buscar",
    order: "Orden",
    source: "Fuente",
    terminal_name: "Fuente",
    device: "Dispositivo",
    address: "Direccion",
    tag_id: "Tag ID",
    amountUSD: "Cantidad",
    btn_export: "Exportar a csv",
    fecha: "Fecha",
    create_date: "Fecha de creación",
    confirm_date: "Fecha confirmación",
    crypto: "Cripto",
    state: "Estado",
    seeMore: "Ver mas",
    delete: "Eliminar",
    btn_transfer: "Transferencia Wirebit",
    coin: "Moneda",
    email: "Correo",
    devices: "Dispositivos",
    wb_transfer: "Transferencia wirebit",
    status: {
      cancelled: "cancelada",
      pending: "pendiente",
      completed: "completada",
      incomplete: "incompleta",
    },
    devices_status: {
      enabled: "activo",
      pending: "pendiente",
      disabled: "desactivado",
    },
    apititle: "Llaves de API",
    status: "ESTATUS",
    documentation: "Documentacion de API",
    select_cripto:
      "Selecciona las criptomonedas que deseas aceptar como forma de pago",
    tolerance: "Rango de tolerancia",
    select_tolerance:
      "Selecciona un rango de tolerancia de cripto faltante para marcar la orden como completada",
    banks: "Cuenta bancaria de retiro",
    select_withdrawal: "Selecciona la frequencia de retiros bancarios",
    fiat_alert:
      "Para seleccionar retiros FIAT es necesario completar el proceso de ",
    kyc: "KYC",
    fiat_alert_2: " y contar con un banco aprobado",

    vex_alert:
      "Para intercambiar criptomonedas a V-USD es necesario completar tu ",
    select_currency: "Selecciona una divisa virtual para tu ecommerce",
    vex_receive: "¿Convertir las criptos recibidas a",
    vex_receive2: "de manera automatica?",
    info_fee: "La conversión de cripto a",
    info_fee2: "genera un cargo del",
    info_fee3: "de la cantidad.",
    notification_options: "Opciones de notificaciones",
    mail_create: "Recibir correo al crearse una orden",
    mail_complete: "Recibir correo al completar la completarse una orden",
    url: "URL de retorno",
    refInput: "Título de referencia",
    web_name: "Direccion web",
    pin_txt: "Utilizar un pin para proteger tu that's it web",
    save: "Guardar Cambios",

    client_info: "Informacion de cliente",
    order_details: "Detalles de compra",
    product: "Producto",
    quantity: "Cantidad",
    usdPrice: "Precio",
    payments: "Pagos de orden",
    mark_complete: "Marcar como completado",
    ex_value: "Cambio Cripto/",
    expected: "Cripto esperado",
    received: "Cripto recibido",
    missing: "Cantidad faltante",

    setup: "Crea tu E-Commerce",
    name: "Nombre de negocio",
    image: "Logo de negocio",
    trans_config: "Configuración de transacciones",
    wallets: "Carteras",
    wallets_password: "Contraseña de carteras",

    estimated_usd: "Saldo estimado en USD",
    estimated_mxn: "Saldo estimado en MXN",
    deviceName: "Nombre",
    deviceUser: "Responsable",
    deviceCoin: "Moneda",
    deviceStatus: "Estado",
    deviceName: "Nombre de dispositivo",
    deviceUserName: "Responsable",
    deviceCoin: "Moneda",
    continue: "Continuar",
    scan: "Escanea el QR",
    typeCode: "Ingresa el el código de tu dispositivo",
    deviceSuccess: "¡Agregado Exitosamente!",
    theDevice: "El dispositivo",
    deviceReady: "esta listo para usarse",
    finish: "Finalizar",
    deviceModalTitle:
      "Disfruta de los beneficios de cobrar con criptomonedas desde tu dispositivo móvil.",
    deviceModal1: `1. Descarga la app “That's it” desde la tienda digital de tu dispositivo.`,
    deviceModal2:
      "2. Sigue las instrucciones para ligar tu dispositivo a tu cuenta Wirebit.",
    send_email_order: "Envío de correo exitoso",
    title_send_email_order: "Éxito",
    error_send_email_order: "Algo salió mal, Intenta más tarde",
    title_error_send_email_order: "Error",
    btn_send_email: "Enviar correo",
  },
  services: {
    title: "Pago de servicios",
    step1: "1. Elige el servicio que deseas pagar",
    step2: "2. Llena los datos necesarios para realizar el pago",
    step3: "3. Elige la cartera con la que quieras pagar",
    referenceNum: "Número de referencia",
    continue: "Continuar con pago",
    amount: "Monto a pagar",
    reference: "Referencia",
    coin: "Tipo de moneda",
    wallet: "Cartera",
    wallet_alias: "Alias de Cartera",
    mxn_price: "Precio Total en MXN",
    crypto_price: "Precio Total en Cripto",
    goBack: "Regresar",
    seeTrans: "Historial de pagos",
    legend: "Solo se aceptan pagos de servicios con recibos emitidos.",
    summary: {
      title_1: "Resumen de pago de servicio",
      title_2: "Metodo de pago",
      confirm: "Confirmar Pago",
      confirmPass: "Confirmar contraseña",
      walletPass: "Contraseña de cartera",
    },
    receipt: {
      title: "¡Confirmación de pago exitoso!",
      cap1: "Fecha de pago",
      cap2: "Servicio a pagar",
      cap3: "Referencia",
      cap4: "Precio Total en Cripto",
    },
    transactions: {
      title: "Historial de pago",
      header: {
        Wallet: "Cartera",
        Servicio: "Servicio",
        Label: "Etiqueta",
        Status: "Estado",
        Amount: "Importe",
        MXN_Amount: "Importe MXN",
        Date: "Fecha",
        TXID: "TXID",
        Reference: "Referencia",
        Receipt: 'Comprobante'
      },
      dataCopies: {
        invalidReference: "inválida",
      },
      filtros: {
        title: "Ordenar por",
        servicio: "Servicio",
        status: "Estatus",
        dateNew: "Fecha más reciente",
        dateOld: "Fecha más antigua",
      },
    },
  },
  contact: {
    section_1: {
      title: "Conoce todo lo",
      title1: "nuevo de Wirebit",
      subtitle: "Descubre todos los beneficios de la nueva criptotarjeta.",
      subtitle2: "Seguridad, Libertad y Tranquilidad para ti.",
    },
    section_2: {
      help_text: "¿Necesitas ayuda?",
      meeting_call: "Agenda una llamada con nuestros asesores",
      call_foreign: "Llama desde el extranjero",
      call_local: "Llama desde el interior de México",
      call_costumer_service: "Teléfono de atención a clientes",
      send_msg: "¡Envíanos un mensaje!",
      schedule: "Lunes a Viernes de 8:00 am a 5:00 pm,",
      time_zone: "horario del centro de México.",
    },
    section_3: {
      donwload_title: "Descarga",
      donwload_title2: "Wirebit Digital",
      donwload_sub: "Disfruta de todos los beneficios de tu",
      donwload_sub2: "tarjeta usando tus criptomonedas de",
      donwload_sub3: "una manera real.",
    },
  },
  checkout:{
    pending:{
      order_details_title: "Detalles de compra",
      email_input: "Ingresa tu correo",
      email_placeholder: "Correo electronico",
      order: "Orden",
      column_title_product: "Producto",
      column_title_quantity: "Cantidad",
      column_title_price: "Precio",
      order_total: "Total",
      payment_title: "Método de pago",
      payment_method_title: "Selecciona un metodo de pago",
      payment_crypto_title: "Selecciona la cripto para tu pago",
      payment_made: "Ya realicé mi pago",
      wirebit_method_name:'Wirebit Transfer',
      wirebit_method_desc:'Transferencia al instante',
      crypto_method_name:'Crypto red',
      crypto_method_desc:'De 10 a 30 min de espera',
    },
    completed:{
      thanks:"¡Gracias por tu compra!",
      order_in_process_01:"Tu orden",
      order_in_process_02:"ha sido procesada",
      return:"Regresar al comercio",
    },
    waiting:{
      thanks:"¡Gracias por tu compra!",
      order_in_process_01:"Tu compra con el numero de orden",
      order_in_process_02:"se encuentra en proceso",
      return:"Regresar al comercio",
    },
    deposits:{
      deposits_title:"Pagos anteriores",
      deposits_TXID_column:"TXID",
      deposits_amount_crypto_column:"Cantidad",
      deposits_amount_currency_column:"Cantidad",
    },
    notifications:{
      copy:{
        title:"Copiado!",
        message:"El texto se copio a tu portapapeles"
      },
      error:{
        title:"¡Error!",
        message:"Utiliza un correo electronico valido"
      },
    },
    wirebit_payment:{
      title: "Pago",
      instructions:"Presiona el link o escanea el QR desde tu app de Wirebit para realizar tu pago",
      link_title:"Link",
      coin_amount:"Cantidad total",
    },
    crypto_payment:{
      title: "Pago",
      instructions:"Deposita la cantidad de cripto en la dirección generada",
      address_title:"Dirección",
      tag_id:"Tag ID",
      coin_amount:"Cantidad total",
      warning:"ADVERTENCIA: Asegúrate de que tu método de pago no genere algún cobro por retiro",
      crypto_method_name:'Crypto red',
    },
    status: {
      cancelled:'cancelada',
      pending:'pendiente',
      completed:'completada',
      incomplete:'incompleta'
    }
  }
};

export default es;
